module.exports = __webpack_public_path__ + "bootleggeres_coffee_box_mockup_packaging_design_corrugated_box_arabica.jpg?dae050a127781942099e233d4fb5aaf7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggeres_coffee_box_mockup_packaging_design_corrugated_box_arabica.jpg
// module id = 23
// module chunks = 0